const propTypes = {};

const defaultProps = {};

const displayName = 'Footer';

export default { propTypes, defaultProps, displayName };
